module.exports = __webpack_public_path__ + "static/media/qr-code.b2e894f4.svg";